module.exports = __webpack_public_path__ + "static/media/check_true.3dd57301.svg";